import { render, staticRenderFns } from "./TestQuestionsAvenantNew.vue?vue&type=template&id=4baf9502&scoped=true&"
import script from "./TestQuestionsAvenantNew.vue?vue&type=script&lang=js&"
export * from "./TestQuestionsAvenantNew.vue?vue&type=script&lang=js&"
import style0 from "./TestQuestionsAvenantNew.vue?vue&type=style&index=0&id=4baf9502&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4baf9502",
  null
  
)

export default component.exports